import http from '../utils/http';

export function intl_student_faq_search(params) {
  return http.post('/api/intl_student_faq/search', params);
}

export function intl_student_faq_answer(id) {
  return http.get(`/api/intl_student_faq/${id}`);
}
